import styled from 'styled-components';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

import ThemeColors from "../../config/themeColors";

interface Props {
    onClick: () => void;
    checked: boolean;
}

const CheckBoxWrapper = styled.button`
    width: 20px;
    height: 20px;
    display: flex;
    border: 1px solid ${ThemeColors.inputBorder};
    border-radius: 5px;
    background: ${ThemeColors.white};
    cursor: pointer;
    padding: 0.1rem;
    svg {
        color: ${ThemeColors.ftgGreen};
        position: relative;
        top: 1px;
    }
    &:disabled {
        pointer-events: none;
    }
    &:focus {
        outline: none;
    }
    margin: 0 auto;
`

const CheckBox = (props: Props) => (

    <CheckBoxWrapper {...props}>
        {props.checked  ? <FontAwesomeIcon icon={faCheck} /> : null}
    </CheckBoxWrapper>
);

export default CheckBox;